// src/components/version/VersionRecord.js
import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from "aws-amplify";

export const VersionRecord = ({ version, index }) => {
  const id = version.id ?? `vr-${index}`;
  return (
    <tr>
      <td className="text-center">
        { version.active ? (
            <span className="badge bg-success">{I18n.get('general_active')}</span>
        ) : (
            <span className="badge bg-danger">{I18n.get('general_inactive')}</span>
        )}
      </td>
      {/**
      <td>{version.no ?? '-'}</td>
       */}
      <td>
        {version.version ?? '-'}
      </td>
      <td>{version.releaseDate ?? '-'}</td>
      {/**
      <td>{version.updatedAt ? String(version.updatedAt).replace('T',' ').replace('Z','') : '-'}</td>
      <td>{version.createdAt ? String(version.createdAt).replace('T',' ').replace('Z','') : '-'}</td>
       */}
    </tr>
  );
};
